import React, { Fragment, useEffect, useMemo, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaFlask } from "react-icons/fa";
import { URL } from '../../utils/urlLibrary';
import { useDispatch, useSelector } from "react-redux";
import { ReactDimmer } from "react-dimmer";
import Menu from "./Menu/Menu";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff as iconLogout } from '@fortawesome/free-solid-svg-icons';
import { actions as usersActions } from '../../reducers/users';
import "./ToggleMenu.scss";

function ToggleMenu() {
  const dispatch = useDispatch();

  const {
    userToken,
    menu,
    authenticated,
    authenticatedError,
  } = useSelector(state => state.users);
  const [isMenuPinned, setMenuPinned] = useState(false);
  const [isMenuHovered, setMenuHovered] = useState(false);
  const routerLocation = useSelector(state => state.router?.location?.pathname || URL.home.hash);

  const publicRoutes = [URL.home.hash, URL.register.hash];
  const showHeader = userToken && !publicRoutes.includes(routerLocation);
  const authenticatedUserName = authenticated?.user || authenticated?.email || '';
  const authenticatedUserInitial = authenticatedUserName ? authenticatedUserName.charAt(0).toUpperCase() : '?';
  const authenticatedRoleLabel = useMemo(() => {
    switch (authenticated?.rol) {
      case 'admin':
        return 'Administrador';
      case 'academia':
        return 'Academia';
      case 'user':
        return 'Alumno';
      default:
        return authenticated?.rol || '';
    }
  }, [authenticated]);

  const makeLogout = () => {
    localStorage.setItem("logout", Date.now());
    dispatch(
      usersActions.makeLogout()
    )
  };

  const supportsHover = typeof window !== 'undefined'
    && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const isMenuOpen = isMenuPinned || isMenuHovered;

  useEffect(() => {
    if (isMenuOpen && typeof window !== 'undefined') {
      window.dispatchEvent(new Event('wajujogido:menu-open'));
    }
  }, [isMenuOpen]);

  const openMenuByHover = () => {
    if (supportsHover) {
      setMenuHovered(true);
    }
  };

  const closeHoveredMenu = () => {
    if (supportsHover) {
      setMenuHovered(false);
    }
  };

  const handleMenuToggle = () => {
    setMenuPinned((prevState) => !prevState);
  };

  const closeMenu = () => {
    setMenuPinned(false);
    setMenuHovered(false);
  };

  const goToMain = () => {
    window.location.href = `#${URL.main.hash}`;
  };

  const goToUserSetup = () => {
    window.location.href = `#${URL.userSetup.hash}`;
    closeMenu();
  };

  if (!showHeader) {
    return null;
  }

  return (
    <Fragment>
      <div className="app">
        <div className="header">
          <div className="header__left">
            {(menu) && (
              <button type="button" className="menu-btn" onClick={handleMenuToggle} onMouseEnter={openMenuByHover} aria-label="Abrir menú">
                <GiHamburgerMenu />
              </button>
            )}
            <button type="button" className="header__brand" onClick={goToMain}>
              <span className="header__brand-logo">
                <FaFlask />
              </span>
              <span className="header__brand-copy">
                <span className="header__brand-name">PlayQir Pro</span>
                <span className="header__brand-claim">Preparación inteligente para exámenes</span>
              </span>
            </button>
          </div>
          {authenticated && userToken && !authenticatedError && (
            <div className="header__actions">
              <button type="button" className="header__profile" onClick={goToUserSetup}>
                <span className="header__avatar">{authenticatedUserInitial}</span>
                <span className="header__identity">
                  <span className="header__user">{authenticatedUserName}</span>
                  <span className="header__role">{authenticatedRoleLabel}</span>
                </span>
              </button>
              <button type="button" className="logout-btn" onClick={makeLogout} aria-label="Cerrar sesión">
                <FontAwesomeIcon icon={iconLogout} className="logout-icon" />
              </button>
            </div>
          )}
        </div>
      </div>
      <div className={`app-menu ${isMenuOpen ? "menu-open" : ""}`} onMouseEnter={openMenuByHover} onMouseLeave={closeHoveredMenu}>
        {(menu) && <Menu isMenuOpen={isMenuOpen} onToggle={handleMenuToggle} onClose={closeMenu} menuContent={menu} />}
      </div>
      <ReactDimmer
        isOpen={isMenuPinned}
        exitDimmer={closeMenu}
        zIndex={100}
        blur={1.5}
      />
    </Fragment>
  );
}

export default ToggleMenu;
